import { useMutation } from '@apollo/client';
import { Actions, Button, Dialog, useToast } from 'braid-design-system';
import queryString from 'query-string';
import { Fragment, useState } from 'react';

import { configValues } from 'src/config';
import Routes from 'src/config/routes';
import { DeleteUserDocument } from 'src/generated/graphql';

const DeleteButton = () => {
  const showToast = useToast();
  const [deleteUser] = useMutation(DeleteUserDocument);
  const [isOpen, toggleOpen] = useState(false);

  const onDeleteButtonClick = async () => {
    try {
      await deleteUser();
      window.location.assign(
        `${queryString.stringifyUrl({
          url: configValues.HEADER_SERVER_BASE + Routes.SIGN_OUT_URL,
          query: {
            returnPath: '/sign-out?returnurl=/',
          },
        })}`,
      );
    } catch {
      showToast({
        tone: 'critical',
        message: 'Delete profile error',
        description:
          'Something went wrong while deleting your profile. Please try again.',
        data: { testid: 'delete-profile-error-toast' },
      });
    }
  };

  return (
    <Fragment>
      <Button
        id="delete-profile-button"
        tone="critical"
        variant="soft"
        onClick={() => toggleOpen(true)}
      >
        Delete my profile
      </Button>

      <Dialog
        id="delete-profile-dialog"
        title="Are you sure you want to delete your profile?"
        open={isOpen}
        width="small"
        onClose={() => toggleOpen(false)}
      >
        <Actions>
          <Button
            id="delete-profile-yes-button"
            tone="critical"
            onClick={onDeleteButtonClick}
          >
            Delete my profile
          </Button>

          <Button
            id="delete-profile-cancel-button"
            tone="neutral"
            variant="transparent"
            onClick={() => toggleOpen(false)}
          >
            Cancel
          </Button>
        </Actions>
      </Dialog>
    </Fragment>
  );
};
export default DeleteButton;
